<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LWFKNA/tc-custom/9781609454029.jpg?1705778526948" alt="This image is the cover for the book Followers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Followers
      </h1>
      <p class="bookDescription body article font2">
        <b>“A profoundly unsettling, brilliantly executed, and deeply humane depiction of a slow slide toward an unspeakable act . . . A remarkable novel” (Emily St. John Mandel, author of <i>Station Eleven</i></b><b>).</b><br/>  <br/> Judith has been visiting her mother, Stephanie, in prison once a month for the last eight years. She still can’t bring herself to talk with her mother about what brought them here—or about Nathaniel, the man whose religious cult almost cost them their lives.<br/>  <br/> When Stephanie first meets him, she is a struggling single mother and Nathaniel is a charismatic outsider, unlike anyone she’s ever known. In deciding to join the group he’s founded, Stephanie thinks she’s doing the best thing for her daughter: a new home, a new purpose. Judith and Stephanie are initiated into a secret society whose “followers” must obey the will of a zealous prophet. As Stephanie immerses herself in her new life, Judith slowly realizes the moral implications of the strict lifestyle Nathaniel preaches. Tensions deepen, faith and doubt collide, and a horrifying act of violence changes everything. In the shattering aftermath, it seems that no one is safe.<br/>  <br/> With “propulsive plotting” (<i>The Guardian</i>), <i>The Followers</i> is a novel about love, hope, and identity that asks: Are we still responsible for our actions if we remake ourselves in someone else’s image? And can there be a way back?<br/>  <br/> “With skillful judgment, Wait shows us that not everyone can be trained or scared into submission. The tenderness and the transformative nature of the ending are truly moving.” —<i>The Independent</i><br/>  <br/> “Brooding tension . . . building to a page-turning finish.” —<i>Daily Mail</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca Wait
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1202f84e